<template>
  <v-app-bar
    color="#D4C304"
    app flat
    height="80px"
    depressed style="background: #D4C304"
  >
    <a href="/">
      <div
        class="app-bar-logo"
        :style="{'background-image': 'url(/static/lk/img/logo_2.svg)'}"
      />
    </a>
    <v-spacer/>

    <template v-if="agent" class="v-col-2">
      <div class="center-wrapper">
      <div class="header_referral" v-if="agent.referralLink">

      <template v-if="showReferralBlock">
        <div class="referral_link_block">
          <span v-if="isReferralWide">Ваша реферальная ссылка:</span>
          <div class="referral_buttons">
            <v-tooltip
                v-model="tooltipVisible"
                location="top"
                origin="bottom center"
                transition="scale-transition"
            >
              <template #activator="{ refs }">
                <v-btn
                    depressed
                    style="background: transparent; padding: 0; height: 40px; width: 22px; min-width: 0;"
                    @click="copyReferralLink"
                    ref="copyBtn"
                    v-bind="refs"
                >
                  <img src="/static/lk/img/copy.svg" alt="copy">
                </v-btn>
              </template>
              Скопировано!
            </v-tooltip>
            <v-btn
                depressed
                style="background: transparent; padding: 0; height: 40px; width: 22px; min-width: 0;"
                @click="generateQRCode"
            >
              <img src="/static/lk/img/qr_code.svg" alt="qr_code">
              <v-tooltip activator="parent" location="bottom">
                Показать QR-код
              </v-tooltip>
            </v-btn>
          </div>
        </div>

        <a :href="agent.referralLink">
          {{ isReferralWide ? agent.referralLink : 'Открыть' }}
        </a>
      </template>


      </div>
      <v-dialog v-model="showQRModal" max-width="250">
        <v-card>
          <v-card-title>Ваш QR-код</v-card-title>
          <v-card-text>
            <img :src="qrCodeUrl" alt="QR Code">
            <div v-if="copySuccess" class="success-message">
              QR-код скопирован
            </div>
          </v-card-text>
          <v-card-actions class="modal-buttons">
            <v-btn text @click="showQRModal = false">Закрыть</v-btn>
            <v-btn text @click="copyQRCodeToClipboard">Копировать</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      </div>

      <div class="header_say_hi">
        <span>{{ agent.firstName }},</span>
        добро пожаловать<br/>
        в личный кабинет агента
      </div>
      <v-btn
          depressed style="background: #fff; padding: 0; margin-right: 15px; height: 40px; width: 40px; min-width: 0; border-radius: 10px;"
          href="/lk/personal/"
      >
        <img src="/static/lk/img/user.svg">
      </v-btn>
      <v-btn
          depressed style="background: transparent; padding: 0; height: 40px; width: 22px; min-width: 0;"
          href="/logout/"
      >
        <img src="/static/lk/img/exit.svg">
      </v-btn>
    </template>
    <template v-else>
      <v-btn
          depressed style="color: #D4C304"
          href="/login/"
      >
        Вход
      </v-btn>
      <v-btn
          class="ml-4"
          depressed style="color: #D4C304"
          href="/registration/"
      >
        Стать партнером
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import {mapState} from 'vuex'
import QRCode from 'qrcode'

export default {
  name: "AppBar",
  computed: {
    ...mapState(['agent']),
    showReferralBlock() {
      return this.agent && this.agent.referralLink
    },
    isReferralWide() {
      return this.$vuetify.breakpoint.width > 650
    },
  },
  data() {
    return {
      qrCodeUrl: '',
      showQRModal: false,
      copySuccess: false,
      tooltipVisible: false
    }
  },
  methods: {
    copyReferralLink() {
      navigator.clipboard.writeText(this.agent.referralLink).then(() => {
        this.showTooltip();
      }).catch(err => {
        console.error('Ошибка копирования в буфер обмена: ', err);
      });
    },
    showTooltip() {
      this.tooltipVisible = true;
      setTimeout(() => {
        this.tooltipVisible = false;
      }, 1000);
    },
    generateQRCode() {
      QRCode.toDataURL(this.agent.referralLink)
          .then(url => {
            this.qrCodeUrl = url;
            this.showQRModal = true;
          })
          .catch(err => {
            console.error('Ошибка генерации QR-кода: ', err);
          });
    },
    copyQRCodeToClipboard() {
      if (!this.qrCodeUrl) return;

      fetch(this.qrCodeUrl)
          .then(res => res.blob())
          .then(blob => {
            const item = new ClipboardItem({"image/png": blob});
            navigator.clipboard.write([item]).then(() => {
              this.copySuccess = true;

              setTimeout(() => {
                this.copySuccess = false;
              }, 2000);
            }, err => {
              console.error('Ошибка копирования в буфер обмена: ', err);
            });
          });
    },
  }
}
</script>

<style scoped>
.center-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto 0 40px;
}

@media (min-width: 651px) {
  .center-wrapper {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    margin: 0; /* убираем смещения */
  }
}


.app-bar-logo {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-color: #fff;
  height: 80px;
  width: 75px;
  position: absolute;
  top: 0;
  left: 0;
}

.header_say_hi {
  line-height: 1;
  font-size: 12px;
  text-align: right;
  margin-right: 15px;
}

.header_say_hi span {
  font-size: 16px;
  font-weight: 600;
  display: block;
  margin-bottom: 5px;
}

.header_referral {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  a {
    color: black;
    text-decoration: underline;
    display: inline-block;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.referral_link_block {
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  align-items: center;
  font-weight: 600;
}

.referral_buttons {
  display: flex;
  gap: 5px;
  margin-left: 15px;
}

.modal-buttons {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.success-message {
  color: green;
  margin-top: 10px;
}
</style>